<template>
  <section>
    <SoAlert v-if="usageBand" type="warning" class="mb-4">
      {{ usageBand }} usage according to Ofgem Averages
    </SoAlert>

    <SoLink
      text="See Ofgem Averages"
      :icon="expanded ? 'chevron-up' : 'chevron-down'"
      @click="expanded = !expanded"
    ></SoLink>

    <v-expand-transition>
      <div v-show="expanded">
        <SoSimpleTable
          :headers="[
            ' ',
            'Gas',
            'Electricity 1 - Rate',
            'Electricity 2 - Rate (Total)',
          ]"
          :items="ofgemAveragesTableData"
          outlined
          class="py-2"
        >
          <p>Daytime: 58% usage</p>
        </SoSimpleTable>
      </div>
    </v-expand-transition>
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoLink from "@/components/SoLink.vue"
  import { UsageEstimationService } from "@/services/UsageEstimationService"
  import { BasicUsageIntensity } from "@/services/UsageEstimationService/types"

  export default defineComponent({
    components: {
      SoAlert,
      SoLink,
      SoSimpleTable,
    },
    props: {
      usageBand: {
        type: String as PropType<BasicUsageIntensity>,
        default: null,
      },
    },
    data() {
      return {
        expanded: false,
      }
    },
    computed: {
      ofgemAveragesTableData() {
        const ofgemProfiles = UsageEstimationService.getOfgemUsageProfiles()
        return Object.entries(ofgemProfiles).map(([category, usage]) => [
          category,
          usage.gasUsage,
          usage.electricityUsage,
          usage.electricityTwoRateUsage,
        ])
      },
    },
  })
</script>
